import Layout from '@/views/layouts/Layout';

import bikeOverviewRouter from './bike-overview';
import diagnosisRouter from './diagnosis';

const servicePointsRouter = {
  path: '/service-tools',
  name: 'Service Tools',
  component: Layout,
  meta: { title: 'serviceTools', icon: 'fa-bicycle', nested: 'true' },
  children: [
    bikeOverviewRouter,
    diagnosisRouter,
    {
      path: 'update',
      name: 'Update',
      component: () => import('@/views/service-tools/update/Update.vue'),
      meta: { title: 'update', icon: '' }
    },
    {
      path: 'setting',
      name: 'Setting',
      component: () => import('@/views/service-tools/Setting.vue'),
      meta: { title: 'setting', icon: '' }
    }
  ]
};

export default servicePointsRouter;
